import React from "react";
import i18n from "i18next";

export const TooltipSeatPreview = (target: any) => (
    <div
        className="wrapper_in_tooltip_seats"
        style={{ borderLeft: `5px solid ${target.category?.color ?? ""}` }}
    >
        {target.category && (
            <div
                className="box_name_category"
                style={{ color: target.category.color }}
            >
                <p>{target.category.name}</p>
            </div>
        )}

        {target.restrictedView && (
            <div
                className="box_name_icons"
                style={{ borderColor: target.category.color }}
            >
                <p style={{ color: target.category.color }}>
                    <span className="icon-restricted-view"></span>
                    <span>{i18n.t("tooltipSeat.restrictedView")}</span>
                </p>
            </div>
        )}
        {target.accesible && (
            <div
                className="box_name_icons"
                style={{ borderColor: target.category.color }}
            >
                <p style={{ color: target.category.color }}>
                    <span className="icon-accesible"></span>
                    <span>{i18n.t("tooltipSeat.accessible")}</span>
                </p>
            </div>
        )}
        {target.companion && (
            <div
                className="box_name_icons"
                style={{ borderColor: target.category.color }}
            >
                <p style={{ color: target.category.color }}>
                    <span className="icon-companion"></span>
                    <span>{i18n.t("tooltipSeat.companion")}</span>
                </p>
            </div>
        )}

        <div className="box_details_seats">
            <p>
                <span>
                    {i18n.t("tooltipSeat.section")}:{" "}
                    <strong>{target.group.section.label || "?"}</strong>
                </span>
                &nbsp;
            </p>
            <p>
                <span>
                    {i18n.t("tooltipSeat.row")}:{" "}
                    <strong>{target.group.row.label || "?"}</strong>{" "}
                </span>
                &nbsp;&nbsp;&nbsp;
                <span>
                    {i18n.t("tooltipSeat.seat")}: <strong>{target.label || "?"}</strong>
                </span>
            </p>
        </div>
    </div>
)
